import React, { useEffect, useState } from 'react';
import Card from '../../components/ui/Card';
import Btn from '../../components/ui/Btn';
import Badge from '../../components/ui/Badge';
import { Select } from '../../components/ui/Input';
import { decimoTerceiroApi } from '../../api/rh';
import { COLORS } from '../../theme';
import { useTituloPagina } from '../../context/PageTitleContext';

function formatarReais(v) {
  return (Number(v) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

const ANO_ATUAL = new Date().getFullYear();
const ANOS = Array.from({ length: 4 }, (_, i) => ANO_ATUAL - 2 + i).map(a => ({ value: String(a), label: String(a) }));

export default function DecimoTerceiroList() {
  useTituloPagina('13º Salário');
  const [ano, setAno] = useState(String(ANO_ATUAL));
  const [registros, setRegistros] = useState([]);
  const [calculando, setCalculando] = useState(false);

  const carregar = () => decimoTerceiroApi.listar(ano).then(setRegistros).catch(() => {});
  useEffect(() => { carregar(); }, [ano]); // eslint-disable-line

  const calcular = async () => {
    setCalculando(true);
    try {
      await decimoTerceiroApi.calcular(ano);
      carregar();
    } catch (e) {
      alert(e.message);
    } finally {
      setCalculando(false);
    }
  };

  const pagarPrimeira = async (id) => { await decimoTerceiroApi.pagarPrimeira(id); carregar(); };
  const pagarSegunda = async (id) => { await decimoTerceiroApi.pagarSegunda(id); carregar(); };

  const totais = registros.reduce((acc, r) => ({
    bruto: acc.bruto + Number(r.valor_bruto),
    primeira: acc.primeira + Number(r.primeira_parcela_valor),
    segunda: acc.segunda + Number(r.segunda_parcela_valor)
  }), { bruto: 0, primeira: 0, segunda: 0 });

  return (
    <div>
      <Card style={{ marginBottom: 14 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 12, marginBottom: 12 }}>
          <Select label="Ano" options={ANOS} value={ano} onChange={e => setAno(e.target.value)} style={{ width: 140 }} />
          <Btn onClick={calcular} disabled={calculando}>{calculando ? 'Calculando...' : 'Calcular / Recalcular 13º do Ano'}</Btn>
        </div>
        <p style={{ fontSize: 12, color: COLORS.textMid, margin: 0 }}>
          1ª parcela: metade do bruto, sem desconto. 2ª parcela: valor restante já com o INSS configurado descontado (sem IRRF). Parcelas já pagas não são recalculadas.
        </p>
        <div style={{ display: 'flex', gap: 12, marginTop: 12, flexWrap: 'wrap' }}>
          <div style={{ background: COLORS.bg, borderRadius: 10, padding: 14, flex: 1, minWidth: 160 }}>
            <div style={{ fontSize: 11, color: COLORS.textLight, textTransform: 'uppercase', fontWeight: 700 }}>Total Bruto</div>
            <div style={{ fontSize: 20, fontWeight: 700 }}>{formatarReais(totais.bruto)}</div>
          </div>
          <div style={{ background: COLORS.primaryBg, borderRadius: 10, padding: 14, flex: 1, minWidth: 160 }}>
            <div style={{ fontSize: 11, color: COLORS.primary, textTransform: 'uppercase', fontWeight: 700 }}>1ª Parcela</div>
            <div style={{ fontSize: 20, fontWeight: 700, color: COLORS.primary }}>{formatarReais(totais.primeira)}</div>
          </div>
          <div style={{ background: COLORS.primaryBg, borderRadius: 10, padding: 14, flex: 1, minWidth: 160 }}>
            <div style={{ fontSize: 11, color: COLORS.primary, textTransform: 'uppercase', fontWeight: 700 }}>2ª Parcela</div>
            <div style={{ fontSize: 20, fontWeight: 700, color: COLORS.primary }}>{formatarReais(totais.segunda)}</div>
          </div>
        </div>
      </Card>

      <Card style={{ padding: 0, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ textAlign: 'left', background: COLORS.bg }}>
              <th style={{ padding: 10 }}>Funcionário</th>
              <th style={{ padding: 10 }}>Avos</th>
              <th style={{ padding: 10 }}>Bruto</th>
              <th style={{ padding: 10 }}>1ª Parcela</th>
              <th style={{ padding: 10 }} />
              <th style={{ padding: 10 }}>2ª Parcela</th>
              <th style={{ padding: 10 }} />
            </tr>
          </thead>
          <tbody>
            {registros.map(r => (
              <tr key={r.id} style={{ borderTop: `1px solid ${COLORS.border}` }}>
                <td style={{ padding: 10, fontWeight: 600 }}>{r.funcionario_nome}</td>
                <td style={{ padding: 10 }}>{r.avos}/12</td>
                <td style={{ padding: 10 }}>{formatarReais(r.valor_bruto)}</td>
                <td style={{ padding: 10 }}>{formatarReais(r.primeira_parcela_valor)}</td>
                <td style={{ padding: 10 }}>
                  {r.primeira_parcela_paga
                    ? <Badge tom="sucesso">Paga</Badge>
                    : <Btn tamanho="sm" onClick={() => pagarPrimeira(r.id)}>Pagar 1ª</Btn>}
                </td>
                <td style={{ padding: 10 }}>{formatarReais(r.segunda_parcela_valor)}</td>
                <td style={{ padding: 10 }}>
                  {r.segunda_parcela_paga
                    ? <Badge tom="sucesso">Paga</Badge>
                    : <Btn tamanho="sm" onClick={() => pagarSegunda(r.id)}>Pagar 2ª</Btn>}
                </td>
              </tr>
            ))}
            {registros.length === 0 && (
              <tr><td colSpan={7} style={{ padding: 20, textAlign: 'center', color: COLORS.textMid }}>Nenhum 13º calculado pra {ano} ainda.</td></tr>
            )}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
